// Header mini-cart: dropdown, quantity +/- saved automatically via AJAX,
// refresh after WooCommerce AJAX events, "Do košíku" button state.

const SELECTOR = '[data-minicart]';
const ADDED_TEXT = 'Přidáno';
const SAVE_DELAY = 500;

let saveTimer = null;

function getRoot() {
    return $(SELECTOR).first();
}

function setOpen(open) {
    const $root = getRoot();
    $root.toggleClass('is-open', open);
    $root.find('[data-minicart-toggle]').attr('aria-expanded', open ? 'true' : 'false');
}

function refreshFragments() {
    $(document.body).trigger('wc_fragment_refresh');
}

function applyFragments(fragments) {
    if (!fragments) {
        return;
    }
    $.each(fragments, function (selector, html) {
        $(selector).replaceWith(html);
    });
}

function saveQuantities() {
    const $root = getRoot();
    const $form = $root.find('[data-minicart-form]');

    if (!$form.length) {
        return;
    }

    const data = {
        action: 'fre_update_mini_cart',
        nonce: $root.data('nonce'),
    };

    $form.serializeArray().forEach(function (field) {
        data[field.name] = field.value;
    });

    $root.addClass('is-loading');

    $.post($root.data('ajax-url'), data)
        .done(function (response) {
            if (response && response.fragments) {
                applyFragments(response.fragments);
                // keep WooCommerce sessionStorage fragments in sync
                refreshFragments();
            }

            const $body = $(document.body);
            if ($body.hasClass('woocommerce-cart')) {
                window.location.reload();
            } else if ($body.hasClass('woocommerce-checkout')) {
                $body.trigger('update_checkout');
            }
        })
        .always(function () {
            $root.removeClass('is-loading');
        });
}

function scheduleSave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveQuantities, SAVE_DELAY);
}

function init() {
    const $doc = $(document);
    const $body = $(document.body);

    // Toggle dropdown
    $doc.on('click', '[data-minicart-toggle]', function (e) {
        e.preventDefault();
        setOpen(!getRoot().hasClass('is-open'));
    });

    // Close on outside click / Esc
    $doc.on('click', function (e) {
        const $root = getRoot();
        if ($root.hasClass('is-open') && !$(e.target).closest(SELECTOR).length) {
            setOpen(false);
        }
    });

    $doc.on('keydown', function (e) {
        if (e.key === 'Escape' && getRoot().hasClass('is-open')) {
            setOpen(false);
        }
    });

    // +/- (saved automatically after a short delay, so fast clicks = one request)
    $doc.on('click', '[data-minicart-step]', function () {
        const $input = $(this).closest('[data-minicart-qty]').find('.fre-minicart__qty-input');
        const step = parseInt($(this).data('minicart-step'), 10) || 0;
        const min = parseInt($input.attr('min'), 10) || 0;
        const max = parseInt($input.attr('max'), 10);
        let value = (parseInt($input.val(), 10) || 0) + step;

        value = Math.max(min, value);
        if (!isNaN(max) && max > 0) {
            value = Math.min(max, value);
        }

        $input.val(value).trigger('change');
    });

    $doc.on('change', '.fre-minicart__qty-input', function () {
        $(this).closest('.fre-minicart__item').toggleClass('is-removed', (parseInt(this.value, 10) || 0) === 0);
        scheduleSave();
    });

    // Enter in the quantity field
    $doc.on('submit', '[data-minicart-form]', function (e) {
        e.preventDefault();
        clearTimeout(saveTimer);
        saveQuantities();
    });

    // Refresh mini-cart after cart changes made elsewhere (cart page AJAX, removals)
    $body.on('updated_wc_div updated_cart_totals removed_from_cart', refreshFragments);

    // "Do košíku" (ajax_add_to_cart) – darker + "Přidáno"
    // (WooCommerce itself replaces the mini-cart fragments from the add-to-cart response)
    $body.on('added_to_cart', function (e, fragments, cartHash, $button) {
        if ($button && $button.length) {
            $button.addClass('added').text($button.data('added-text') || ADDED_TEXT);
        }
    });
}

export default { init };
